import {useRef} from "react";
import {useSelector} from "react-redux";
import {selectCurrentUser} from "../redux/user/userSlice";
import {useTranslation} from "react-i18next";

export const PostCommentInput = ({handleChange,setDisplayModal,displayModal,submitComment,addMentions,search,users}) =>{
    const { t } = useTranslation();
    const ref = useRef(null);
    const { user } = useSelector(selectCurrentUser);
    function clickAddMentions(user,search){
        if(search!==""){
            ref.current.value = ref.current.value.replace("@"+search,'@'+user.firstname.replace(' ','')+" ");
        }else{
            ref.current.value = ref.current.value +user.firstname.replace(' ','');
        }
        addMentions(user);
        setDisplayModal(false);
    }

    return (
        <div className={'postCommentGlobalContainer'}>
            <div className={'postCommentInputContainer'}>
                <img src={user.img} alt={users.firstname} className={'postCommentInputImg'} onError={(e)=>e.target.style.visibility = "hidden"} />
                <div className={'formatedTextContainer'}>
                    <p className={'formatedText'}></p>
                </div>

                <input placeholder={t('Ecrire un commentaire...')} className={"postCommentInputIntput"}
                       ref={ref} onFocus={handleChange} onInput={handleChange} autoFocus />

                <div onClick={()=>{ref.current.value = ref.current.value +' @'; ref.current.focus();}}><div className={'postCommentMentionInput'}></div></div>
                <div onClick={()=>{submitComment(ref.current.value);ref.current.value = "";}} className={(ref.current && ref.current.value.length===0)? 'postCommentSubmit':'postCommentSubmit active' }>{t('Publier')}</div>
            </div>
            <ModalUserList search={search} addMentions={clickAddMentions} display={displayModal} users={users} />
        </div>)
}

const ModalUserList = ({display,search,addMentions,users}) =>{
    const classDisplay = display? "":"hide";
    return (<div className={'userListContainer '+classDisplay}>
        {users.filter((user) => {
            return user.firstname.includes(search) || user.lastname.includes(search)
        }).map((item)=>{
            return <UserItem key={item.id} addMentions={addMentions} search={search} user={item}/>
        })}
    </div>)
}

const UserItem = ({user,addMentions,search}) =>{

    return (<div onClick={()=> {addMentions(user,search);}} className={'userContainer'}>
        {user.img && <img alt={user.firstname + " " + user.lastname} className={'postCommentInputImg'} src={user.img} onError={(e)=>e.target.style.display = "none"} />}
        <p className={'userName'}>{user.firstname + " " + user.lastname}</p>
    </div>)
}
